import { render } from "./HeroSideBarModal.vue?vue&type=template&id=7807d79e&scoped=true"
import script from "./HeroSideBarModal.vue?vue&type=script&lang=js"
export * from "./HeroSideBarModal.vue?vue&type=script&lang=js"

import "./HeroSideBarModal.vue?vue&type=style&index=0&id=7807d79e&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7807d79e"]])

export default __exports__